"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContestLogin = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var RaisedButton_1 = __importDefault(require("@atg/icf-react-components/components/RaisedButton"));
var react_jss_1 = require("react-jss");
var useContestLoginStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    contestLoginLayout: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
    },
    contestLoginPanel: {
        borderWidth: "2px",
        borderStyle: "solid",
        borderColor: theme.colors.baseContrast050,
        padding: "42px 48px",
        margin: "48px 16px",
        color: theme.colors.baseContrast090,
        backgroundColor: theme.colors.baseContrast020,
    },
    contestLoginTitle: {
        fontSize: "24px",
    },
    contestLoginMessage: {
        fontSize: "14px",
        padding: "24px 0",
    },
    contestLoginButtons: {
        display: "flex",
        justifyContent: "space-between",
    },
    contestLoginButtonContainer: {
        width: "calc(50% - 8px)",
        height: "100%",
    },
}); });
var ContestLogin = function (_a) {
    var onLoginClicked = _a.onLoginClicked, onJoinClicked = _a.onJoinClicked, translate = _a.translate;
    var classes = useContestLoginStyles();
    return ((0, jsx_runtime_1.jsx)("div", { className: classes.contestLoginLayout, children: (0, jsx_runtime_1.jsxs)("div", { className: classes.contestLoginButtonContainer, children: [(0, jsx_runtime_1.jsx)("div", { className: classes.contestLoginTitle, children: translate("search.contest_login.title") }), (0, jsx_runtime_1.jsx)("div", { className: classes.contestLoginMessage, children: translate("search.contest_login.description") }), (0, jsx_runtime_1.jsxs)("div", { className: classes.contestLoginButtons, children: [(0, jsx_runtime_1.jsx)("div", { className: classes.contestLoginButtonContainer, children: (0, jsx_runtime_1.jsx)(RaisedButton_1.default, { "data-ta-locator": "ContestLoginButton", label: translate("login.login"), onClick: onLoginClicked, size: "large", fullWidth: true }) }), (0, jsx_runtime_1.jsx)("div", { className: classes.contestLoginButtonContainer, children: (0, jsx_runtime_1.jsx)(RaisedButton_1.default, { "data-ta-locator": "ContestJoinButton", label: translate("login.free_account"), onClick: onJoinClicked, size: "large", gold: true, fullWidth: true }) })] })] }) }));
};
exports.ContestLogin = ContestLogin;
exports.ContestLogin.displayName = "ContestLogin";
//# sourceMappingURL=ContestLogin.js.map